export default {
      id: "bitcointalk-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#bitcointalk",
      toString: function () {
        return this.url;
      }
    }